import React from "react";
import { useTranslation } from "react-i18next";
import { Tag, Button } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { FORMAT_OPTIONS, FEEDBACK_FORMAT } from "./constants";
import FormatWaitlistButton from "./FormatWaitlistButton";
import styles from "./style.module.scss";

const FORMAT_EMOJI = {
  text: "📝",
  voice: "🎙️",
  video: "📹",
};

const FormatLaunchpad = ({
  onSelect,
  waitlistJoined,
  waitlistLoading,
  onJoinWaitlist,
  capabilities,
  onUpgrade,
}) => {
  const { t } = useTranslation();
  const canVoice = !!capabilities?.canVoice;

  return (
    <div className={styles.launchpad}>
      <p className={styles.launchpadIntro}>{t("feedbackCapture.launchpad_intro")}</p>
      <div className={styles.launchpadGrid}>
        {FORMAT_OPTIONS.map((option) => {
          const isComingSoon = option.comingSoon;
          const voiceLocked =
            option.key === FEEDBACK_FORMAT.VOICE && !canVoice && !isComingSoon;
          const locked = isComingSoon || voiceLocked;
          const CardTag = locked ? "div" : "button";
          return (
            <CardTag
              key={option.key}
              type={locked ? undefined : "button"}
              className={[
                styles.launchpadCard,
                locked ? styles.launchpadCardComingSoon : "",
              ].join(" ")}
              onClick={
                locked
                  ? undefined
                  : () => {
                      onSelect(option.key);
                    }
              }
            >
              <span className={styles.launchpadEmoji} aria-hidden>
                {FORMAT_EMOJI[option.key]}
              </span>
              <div className={styles.launchpadCardBody}>
                <div className={styles.launchpadCardTitleRow}>
                  <h3 className={styles.launchpadCardTitle}>
                    {t(option.titleKey)}
                  </h3>
                  {isComingSoon ? (
                    <Tag className={styles.formatCardSoon}>
                      {t("feedbackCapture.format_coming_soon")}
                    </Tag>
                  ) : null}
                  {voiceLocked ? (
                    <Tag className={styles.formatCardSoon}>
                      {t("surveyManagement.survey_pro_badge", "Pro")}
                    </Tag>
                  ) : null}
                </div>
                <p className={styles.launchpadCardDesc}>{t(option.descKey)}</p>
                {isComingSoon && option.waitlistFeature ? (
                  <FormatWaitlistButton
                    joined={!!waitlistJoined?.[option.waitlistFeature]}
                    loading={!!waitlistLoading?.[option.waitlistFeature]}
                    onJoin={() => onJoinWaitlist(option.waitlistFeature)}
                  />
                ) : null}
                {voiceLocked ? (
                  <p className={styles.launchpadCardDesc}>
                    <LockOutlined /> {t("feedbackCapture.format_voice_locked")}{" "}
                    {onUpgrade ? (
                      <Button type="link" size="small" onClick={() => onUpgrade("pro")}>
                        {t("surveyManagement.upgrade_plan_cta")}
                      </Button>
                    ) : null}
                  </p>
                ) : null}
              </div>
            </CardTag>
          );
        })}
      </div>
    </div>
  );
};

export default FormatLaunchpad;
